import { useParams } from 'react-router-dom';
import {
  SourceSettings,
  SourceSettingsProps
} from '../../../../sources/SourceSettings/SourceSettings';
import { SourceAPI } from '../../../../sources/api/SourceAPI';
import { EntityFormState } from '../../../../entity-form/interfaces/entity-form';
import { templateFormConnectionParamsFactory } from '../../../../template-form/factories/templateFormConnectionParamsFactory';
import { Source } from '../../../../shared/interfaces/source';
import { ResolvedComponent } from '../../../../routing/ResolvedComponent';
import { PipelineAPI } from '../../../api/PipelineAPI';
import { IntegrationFactory } from '../../../factories/integrationFactory';
import { EditEntity } from '../../../../shared/components/EditEntity/EditEntity';

export function PipelineEditSource() {
  const { id } = useParams();

  const sourceResolver = () =>
    PipelineAPI.getIntegration(Number(id!)).then(res => IntegrationFactory(res.data).source);

  return (
    <ResolvedComponent
      Component={EditSourceInner}
      resolve={{
        source: sourceResolver
      }}
    />
  );
}

function EditSourceInner({ source }: { source: Source }) {
  const formDataResolver = () => {
    return SourceAPI.getSourceConfigTemplateWithFormData(source.id);
  };

  const formSubmitResolver = (values: EntityFormState) => {
    const connectionParams = templateFormConnectionParamsFactory(values);

    return SourceAPI.editSource(source.id, connectionParams);
  };

  const testConnectionResolver = (values: EntityFormState) => {
    const buildParams = templateFormConnectionParamsFactory(values);
    return SourceAPI.getTestConnectionTaskIdForSourceEdit(source.id, buildParams);
  };

  return (
    <EditEntity<SourceSettingsProps>
      name={source.name}
      FormComponent={SourceSettings}
      cancelUrl='../job-history'
      isCancelUrlPathRelative
      componentProps={{
        formDataResolver,
        formSubmitResolver,
        testConnectionResolver,
        isSBSDocsAllowed: true,
        mode: 'EDIT'
      }}
    />
  );
}
